import b from 'b_';
import { Close } from 'education-icons';
import React, { ReactInstance } from 'react';

import Link, { LinkProps } from '../__link/hint__link';
//@ts-ignore
import withRootResizeDetection from '../../../utils/hocs/with-root-resize-detection/with-root-resize-detection.jsx';
import { POPUP_AXIS, POPUP_DIRECTIONS, POPUP_THEMES, OffsetValue } from '../../constants';
//@ts-ignore
import Markdown from '../../markdown/markdown';
import Popup, { Props as PopupProps } from '../../popup/popup';

import './hint_type_call-to-action.scss';

const SHOW_TIMEOUT_MS = 300;
const CONTROL_VIEW_OFFSET = 100;

export interface Props extends PopupProps {
    closeOnTargetClick?: boolean;
    description?: string;
    link?: Omit<LinkProps, 'onClick'>;
    onClose: (params?: { additionalData: object }) => void;
    targetAreaOffset?: { top?: OffsetValue; left?: OffsetValue };
    targetRef: Node;
    withExplicitClose?: boolean;
}

export class HintTypeCallToAction extends React.Component<Props> {
    componentDidMount() {
        const { targetRef } = this.props;

        this.handleTargetRef(targetRef);
    }

    componentDidUpdate() {
        const { targetRef } = this.props;

        this.handleTargetRef(targetRef);
    }

    componentWillUnmount() {
        const { closeOnTargetClick } = this.props;

        clearTimeout(this.showTimer);

        if (closeOnTargetClick && this.targetRef) {
            // @ts-ignore
            this.targetRef.removeEventListener('click', this.handleTargetClick);
        }
    }

    showTimer: ReturnType<typeof setTimeout>;
    targetRef: Node | null = null;
    popupRef: Popup | null = null;
    isTargetRefSet: boolean;

    handlePopupRef = (ref: ReactInstance | null) => {
        if (ref !== null) {
            this.popupRef = ref as Popup;
        }
    };

    handleTargetRef = (ref: Node | null) => {
        if (ref !== null) {
            const { closeOnTargetClick } = this.props;

            if (!this.popupRef || this.isTargetRefSet) {
                return;
            }

            this.isTargetRefSet = true;
            this.targetRef = ref;
            this.popupRef.setOwner(ref);

            if (closeOnTargetClick && this.targetRef) {
                // @ts-ignore
                this.targetRef.addEventListener('click', this.handleTargetClick);
            }

            this.showTimer = setTimeout(this.show, SHOW_TIMEOUT_MS);
        }
    };

    handleTargetClick = () => {
        this.close({
            additionalData: {
                isTargetClicked: true,
            },
        });
    };

    updatePositions = () => {
        if (this.popupRef) {
            this.popupRef.updatePositions();
        }
    };

    show = () => {
        const { axis, direction, targetRef } = this.props;

        if (this.popupRef) {
            this.popupRef.show();

            // @ts-ignore
            const { top: targetTop, height: targetHeight } = targetRef.getBoundingClientRect();
            // @ts-ignore
            const popupHeight = this.popupRef.popup.offsetHeight;
            const isVerticalAxis = direction && [POPUP_DIRECTIONS.LEFT, POPUP_DIRECTIONS.RIGHT].includes(direction);

            let contentOffset = -popupHeight;

            if (isVerticalAxis && axis === POPUP_AXIS.CENTER) {
                contentOffset += targetHeight / 2;
            } else if ((isVerticalAxis && axis === POPUP_AXIS.END) || direction === POPUP_DIRECTIONS.BOTTOM) {
                contentOffset += targetHeight;
            }

            // скролим до того, чтобы таргет был на середине экрана минус offset
            window.scrollTo({
                top: targetTop - window.innerHeight / 2 + contentOffset + CONTROL_VIEW_OFFSET + window.scrollY,
                behavior: 'smooth',
            });
        }
    };

    close = (params: { additionalData: object } = { additionalData: {} }) => {
        const { onClose } = this.props;

        if (this.popupRef) {
            this.popupRef.hide();
        }

        onClose(params);
    };

    handlePopupToggle = (options: { shown: boolean }): boolean => {
        const { onClose } = this.props;

        if (!options.shown) {
            onClose();
            return true;
        }

        return false;
    };

    render() {
        const { description, link, targetRef, title, withExplicitClose, ...popupProps } = this.props;

        if (!targetRef) {
            return null;
        }

        return (
            <div>
                <Popup
                    autoclosable
                    hasArrow
                    inLayer
                    mix={b('hint', { type: 'call-to-action' })}
                    onToggle={this.handlePopupToggle}
                    ref={this.handlePopupRef}
                    theme={POPUP_THEMES.SCHOOL}
                    {...popupProps}
                >
                    <div className="hint__content">
                        {withExplicitClose && (
                            <div
                                className="hint__close-icon"
                                onClick={() => {
                                    this.close();
                                }}
                            >
                                <Close />
                            </div>
                        )}
                        {title && <h3 className="hint__title">{title}</h3>}
                        {description && <Markdown mix="hint__description">{description}</Markdown>}
                        {link && <Link onClick={this.close} {...link} />}
                    </div>
                </Popup>
            </div>
        );
    }
}

export default withRootResizeDetection(HintTypeCallToAction);
